import DistributionStore from '@/components/UI/Distribution/store';
import { ACTIVITY_USER_TYPE, activityCode, getUserActivity } from '@/services/activity';
import UserStore from '@/store/User';

import { MOCK_ENABLE, STORAGE_KEYS } from '../config';
import { CouponManager } from '../coupon/CouponManager';
import { CampaignType, CouponType, StandardCoupon, StrategyContext } from '../types';
import { BaseCampaignStrategy } from './base';

// Mock 数据：活动资格（24小时后到期）
const MOCK_ACTIVITY_DATA = {
  activityUserType: ACTIVITY_USER_TYPE.FREE_USER,
  userTypeExpireTime: Date.now() + 24 * 60 * 60 * 1000,
};

export class FirstOrderCampaignStrategy extends BaseCampaignStrategy {
  type = CampaignType.FIRST_ORDER;
  priority = 80;

  private activityData: {
    activityUserType: number;
    userTypeExpireTime: number;
  } | null = null;

  private closeModalRef: { current: () => void } = { current: () => {} };

  async canActivate(): Promise<boolean> {
    // 1. 有 pattern=2 KOL 分销券时不激活
    if (
      this.topCoupon?.type === CouponType.DISTRIBUTION_ALL ||
      this.topCoupon?.type === CouponType.DISTRIBUTION_SPECIFIC
    ) {
      return false;
    }

    // 2. 查询活动接口
    try {
      let data: typeof MOCK_ACTIVITY_DATA;

      if (MOCK_ENABLE) {
        data = MOCK_ACTIVITY_DATA;
      } else {
        const res = await getUserActivity(activityCode);
        if (res.code !== 200) return false;
        data = res.data;
      }

      this.activityData = data;

      // 3. activityUserType=4 才激活
      if (data.activityUserType !== ACTIVITY_USER_TYPE.FREE_USER) return false;

      // 4. 新用户专享券未过期
      const newUserCoupon = CouponManager.getInstance().getCouponByType(
        CouponType.NEW_USER_EXCLUSIVE,
      );
      return newUserCoupon !== null && (newUserCoupon.leftSeconds || 0) > 0;
    } catch {
      return false;
    }
  }

  show(_context?: StrategyContext): void {
    if (!this.activityData) return;

    const { userTypeExpireTime } = this.activityData;

    // 设置倒计时
    UserStore.getState().setNewUserCountDownTime(
      Math.floor((userTypeExpireTime - Date.now()) / 1000),
    );

    const storageKey = STORAGE_KEYS.FIRST_ORDER_MODAL_SHOWN;

    if (this.shouldShowModal(storageKey)) {
      // 首次：显示弹窗
      import('@/components/UIComponents/CommonModal').then(({ FirstOrderModal }) => {
        FirstOrderModal.show({
          onClose: () => this.handleModalClose(),
          onPayEnd: () => this.handlePayEnd(),
          destroyHandle: this.closeModalRef,
        });
      });
      this.markModalShown(storageKey);
    }
    // 非首次：不展示任何内容
  }

  private handleModalClose(): void {
    // 关闭后不展示横幅
    // this.triggerDistributionInvite();
  }

  private handlePayEnd(): void {
    this.closeModalRef.current?.();
    // this.triggerDistributionInvite();
  }

  private triggerDistributionInvite(): void {
    DistributionStore.getState().setShowInvite(true);
  }
}
